import React, { createContext, useContext, useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../Services/firebase-config';

const RegistrationConfigContext = createContext({
  registrationDeadline: null,
  loading: true,
  error: null,
});

export const RegistrationConfigProvider = ({ children }) => {
  const [registrationDeadline, setRegistrationDeadline] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const ref = doc(db, 'configs', 'registrationDeadline');
    
    // Set up real-time listener
    const unsubscribe = onSnapshot(
      ref,
      (snap) => {
        try {
          if (snap.exists()) {
            const data = snap.data();
            const d = data?.deadline;
            console.log('Fetched registration deadline (real-time):', d);
            setRegistrationDeadline(d || null);
          } else {
            console.log('Registration deadline document does not exist');
            setRegistrationDeadline(null);
          }
        } catch (err) {
          console.error('Error processing registration deadline:', err);
          setError(err);
        } finally {
          setLoading(false);
        }
      },
      (err) => {
        console.error('Error listening to registration deadline:', err);
        setError(err);
        setLoading(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <RegistrationConfigContext.Provider value={{ registrationDeadline, loading, error }}>
      {children}
    </RegistrationConfigContext.Provider>
  );
};

export const useRegistrationConfig = () => useContext(RegistrationConfigContext);

export default RegistrationConfigContext;